/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_To_Your_Command_CenterInputs */

const en_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Your Command Center!`)
};

const es_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Bienvenido a tu centro de mando!`)
};

const fr_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue dans votre Centre de commandement !`)
};

const de_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen in deiner Kommandozentrale!`)
};

const ja_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンドセンターへようこそ！`)
};

const zh_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎来到您的指挥中心！`)
};

const ar_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحباً بك في مركز القيادة الخاص بك!`)
};

const id_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selamat datang di Pusat Komando Anda!`)
};

const it_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto nel tuo Centro di Comando!`)
};

const ru_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать в ваш командный центр!`)
};

const pt_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo ao seu Centro de Comando!`)
};

const ko_welcome_to_your_command_center = /** @type {(inputs: Welcome_To_Your_Command_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커맨드 센터에 오신 것을 환영합니다!`)
};

/**
* | output |
* | --- |
* | "Welcome to Your Command Center!" |
*
* @param {Welcome_To_Your_Command_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const welcome_to_your_command_center = /** @type {((inputs?: Welcome_To_Your_Command_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_To_Your_Command_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_to_your_command_center(inputs)
	if (locale === "es") return es_welcome_to_your_command_center(inputs)
	if (locale === "fr") return fr_welcome_to_your_command_center(inputs)
	if (locale === "de") return de_welcome_to_your_command_center(inputs)
	if (locale === "ja") return ja_welcome_to_your_command_center(inputs)
	if (locale === "zh") return zh_welcome_to_your_command_center(inputs)
	if (locale === "ar") return ar_welcome_to_your_command_center(inputs)
	if (locale === "id") return id_welcome_to_your_command_center(inputs)
	if (locale === "it") return it_welcome_to_your_command_center(inputs)
	if (locale === "ru") return ru_welcome_to_your_command_center(inputs)
	if (locale === "pt") return pt_welcome_to_your_command_center(inputs)
	return ko_welcome_to_your_command_center(inputs)
});